import Action, {
  ActionSizes,
  ActionDefaultSize,
} from './Action';

export default Action;

export {
  ActionSizes,
  ActionDefaultSize,
};
